<template>
    <div class="card card-info">
        <div class="card-header">
            <h3 class="card-title">Prospect Students</h3>
        </div>
        <!-- /.card-header -->
        <!-- form start -->
        <div class="card-body">
            <div class="row">
                <div class="col-md-4">
                    <label>Session *</label>
                    <select class="form-control" v-model="filter.SemesterID" v-on:change="loadOfferedPrograms()">
                        <option value="">--Select Session--</option>
                        <option v-for="item in semesters" v-bind:value="item.SemesterID">{{item.Name}}</option>
                    </select>
                </div>
                <div class="col-md-4">
                    <label>Degree * </label>
                    <select class="form-control" v-model="filter.DegreeID" v-on:change="loadOfferedPrograms()">
                        <option value="">--Select Degree--</option>
                        <option v-for="item in degrees" v-bind:value="item.DegreeID">{{item.Name}}</option>
                    </select>
                </div>
                <div class="col-md-4">
                    <label>Program</label>

                    <select class="form-control" v-model="filter.ProgramID">
                        <option value="0">--Select Program--</option>
                        <option v-for="item in programs" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
                    </select>
                </div>
                <div class="col-md-4">
                    <label>Category</label>

                    <select class="form-control" v-model="filter.CategoryID">
                        <option value="0">--Select Category--</option>
                        <option v-for="item in category" v-bind:value="item.AdmissionCategoryID">{{item.Name}}</option>
                    </select>
                </div>
                <div class="col-md-4">
                    <label>Name/Form No./Father Name/CNIC</label>

                    <input class="form-control" v-model="filter.Name" />
                </div>
                <div class="col-md-4">
                    <label>District</label>

                    <input class="form-control" v-model="filter.District" />
                </div>
                <div class="col-md-4">
                    <label>Document</label>

                    <select class="form-control" v-model="filter.Document">
                        <option value="">--Select--</option>
                        <option value="Verified">Verified</option>
                        <option value="Un-Verified">Un-Verified</option>
                    </select>
                </div>
                <div class="col-md-4">
                    <label>Hostel Required</label>
                    <select class="form-control" v-model="filter.Hostel">
                        <option value="">--Select--</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                </div>
                <div class="col-md-4">
                    <label>Payment</label>

                    <select class="form-control" v-model="filter.Payment">
                        <option value="">--Select--</option>
                        <option value="Verified">Received</option>
                        <option value="Un-Verified">Un-Received</option>
                    </select>
                </div>
                <div class="col-md-4">
                    <label>Application Status</label>
                    <select class="form-control" v-model="filter.ApplicationStatus">
                        <option value="0">--Select Type--</option>
                        <option value="1">Posted</option>
                        <option value="2">Un posted</option>
                    </select>
                </div>
                <div class="col-md-4">
                    <label>Challan Received</label>
                    <select class="form-control" v-model="filter.ChallanReceived">
                        <option value="All">--All--</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                </div>
                <div class="col-md-2" v-if="filter.ApplicationStatus == 1">
                    <div class="form-group">
                        <label>Date From *</label>
                        <input v-model="filter.DateFrom" type="date" class="form-control" required />
                    </div>
                </div>
                <div class="col-md-2" v-if="filter.ApplicationStatus == 1">
                    <div class="form-group">
                        <label>Date To *</label>
                        <input v-model="filter.DateTo" type="date" class="form-control" required />
                    </div>
                </div>
                <div class="col-md-12">
                    <br />
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input" type="checkbox" id="customCheckbox1" value="option1" v-model="filter.DisplayPicture">
                        <label for="customCheckbox1" class="custom-control-label">Display Record With Pictures (It may take some time)</label>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group float-right">
                        <button class="btn btn-primary" type="button" style="margin-top: 20px;" v-on:click="btnSearch()">Search</button>
                        <button class="btn btn-primary" type="button" style="margin-top: 20px;" v-on:click="exportexcel()" v-if="exceldatastatus==='enabled'">Export All Data</button>
                    </div>
                </div>
            </div>

            <div class="row" style="margin-top: 10px" v-if="prospects.length > 0">
                <div class="col-md-12">
                    <hr />
                    <div class="table-responsive">
                        <table id="bs4-table" class="table table-striped table-color table-sm" style="font-size: 12px;">
                            <thead class="bg-info">
                                <tr>
                                    <th style="width: 5px; text-align: center">Sr.#</th>
                                    <th v-show="showImage" style="width: 20px; text-align: center">Image</th>
                                    <th style="width: 20%">Program</th>
                                    <th style="width: 15%">Form #</th>
                                    <th style="width: 20%">Name</th>
                                    <th style="width: 20%">Father Name</th>
                                    <th style="width: 10%">CNIC</th>
                                    <th style="width: 10%">Date</th>
                                    <th style="width: 15%">District</th>
                                    <th style="width: 5px; text-align: center;">Status</th>
                                    <th style="width: 50px; text-align: center;">Verification</th>
                                    <th style="width: 25px; text-align: center;">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(p, ind) in prospects">
                                    <td style="text-align: center; vertical-align: middle">{{ind + 1}}</td>
                                    <td v-show="showImage" style="text-align: center; vertical-align: middle">
                                        <img style="max-height: 60px" v-bind:src="p.temp" />
                                    </td>
                                    <td style="vertical-align: middle">
                                        <span v-for="pr in p.Programs">
                                            {{pr.Priority}}. {{pr.Name}}<br />
                                        </span>
                                    </td>
                                    <td style="vertical-align: middle">{{p.FormNo}}</td>
                                    <td style="vertical-align: middle">
                                        {{p.Name}}
                                        <small v-if="p.OverAge" style="color: red;">
                                            <br />
                                            Over age
                                        </small>
                                        <small v-else-if="p.DEO != ''" style="color: red;">
                                            <br />
                                            DEO: {{p.DEO}}
                                        </small>
                                    </td>
                                    <td style="vertical-align: middle">{{p.FathersName}}</td>
                                    <td style="vertical-align: middle">{{p.CNIC}}</td>
                                    <td style="vertical-align: middle">{{p.Date}}</td>

                                    <td style="vertical-align: middle">{{p.District}}</td>
                                    <td style="vertical-align: middle; text-align: center;">
                                        <i v-if="(p.Tab >= 4)" style="color: #5cb85c">Complete</i>
                                        <i v-else style="color: #d9534f">In Complete</i>
                                        <br />
                                        <i v-if="p.IsPost">Posted</i>
                                        <i v-else>UnPosted</i>
                                    </td>
                                    <td style="vertical-align: middle; text-align: center;">
                                        <i v-if="p.PaymentReceived" style="color: #5cb85c; white-space: nowrap;">Payment <i class="fa fa-check"></i></i>
                                        <i v-else style="color: #d9534f; white-space: nowrap;">Payment <i class="fa fa-remove"></i></i>

                                        <i v-if="p.Verified" style="color: #5cb85c; white-space: nowrap;">Documents <i class="fa fa-check"></i></i>
                                        <i v-else style="color: #d9534f; white-space: nowrap;">Documents <i class="fa fa-remove"></i></i>
                                    </td>
                                    <td style="vertical-align: middle; text-align: center;">
                                        <div class="btn-group-vertical">
                                            <button type="button" class="btn btn-warning" data-toggle="tooltip" title="Edit" v-on:click="edit(p.ProspectStudentID)"><i class="fas fa-edit"></i></button>
                                            <button type="button" v-if="(p.Tab >= 3)" class="btn btn-info" data-toggle="tooltip" title="Print Form" v-on:click="printAdmissionForm(p.ProspectStudentID)"><i class="fas fa-file"></i></button>
                                            <button type="button" v-if="((p.Tab >= 3) && p.IsPost) " class="btn btn-success" data-toggle="tooltip" title="Print Challan" v-on:click="printChallanForm(p.ProspectStudentID)"><i class="fas fa-print"></i></button>
                                            <button type="button" v-if="p.EntryTest && p.Tab >= 3" class="btn btn-primary" data-toggle="EntryTest" title="Entry Test" v-on:click="printEntryTest(p.ProspectStudentID)"><i class="fas fa-file"></i></button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>const axios = require('axios').default;

    export default ({
        data() {
            return {
                departments: [],
                programs: [],
                selDegreeID: 0,
                semesters: [],
                degrees: [],
                filter: { SemesterID: '', ProgramID: 0, ChallanReceived: 'All', CategoryID: 0, DegreeID: '', Hostel: '', Name: '', Payment: '', Document: '', ApplicationStatus: 0, DisplayPicture: false, District: '', DateFrom: '', DateTo: '' },
                prospects: [],
                Types: 1,
                exceldata: [],
                exceldatastatus: 'default',
                delete: { id: '', ind: '' },
                showImage: false,
                category: [],
                depID: 0,
            }
        },

        created: function () {
        },

        mounted: function () {
            this.pageLoad();
        },

        updated: function () {
            if (this.prospects.length != 0) {
                $('#bs4-table').DataTable();
            }
        },

        methods: {

            unpost(id) {
                var vm = this;
                axios.post('/api/AdmissionApi/unpoststudent', {
                    ID: id
                })
                    .then(function (response) {
                        var result = response.data.replace('{"d":null}', '');
                        var data = JSON.parse(result);
                        if (data.status) {
                            toastr.success("Unpost Succsessfully", "Success");
                        }
                        else {
                            toastr.error("You cannot unpost the application, Challan is Uploaded", "Error!");
                        }
                        console.log(response);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            checkFile(file) {
                if (file == null) {
                    return false;
                }

                if (file.size > 200000) {
                    toastr.error("file size is large max size is 200 kb", "Error!");
                    return false;
                }

                if (file.type != "image/jpeg" && file.type != "image/png") {
                    toastr.error("invalid file only image file is allowed");
                    return false;
                }

                return true;
            },

            onfileupload: function (event) {
                if (this.checkFile(event.target.files[0])) {
                    startReq();
                    var image = new Image;
                    this.image = null;
                    var reader = new FileReader;
                    reader.onload = (e) => {
                        this.ch.Attachment = e.target.result;
                    }
                    reader.readAsDataURL(event.target.files[0]);
                    endReq();
                    toastr.success("Uploaded", "Done!");
                }
                else
                    $('#fileUpload').val('');
            },

            loadChallan(id) {
                var vm = this;
                vm.ID = id;
                $('#mdlChallan').modal('show');
            },

            uploadChallan() {
                if (this.ch.ModeOfPayment == 'Deposit' && this.ch.Branch == '') {
                    toastr.error("Branch is required", "Error!")
                }
                else if (this.ch.ModeOfPayment != 'Deposit' && this.ch.TransactionNo == '') {
                    toastr.error("Transaction No. is required", "Error!")
                }
                else if (this.ch.ModeOfPayment == 'Deposit' && this.ch.DepositDate == '') {
                    toastr.error("Deposit Date is required", "Error!")
                }
                else if (this.ch.ModeOfPayment != 'Deposit' && this.ch.DepositDate == '') {
                    toastr.error("Transaction Date is required", "Error!")
                }
                else if (this.ch.ModeOfPayment == 'Deposit' && this.ch.Attachment == '') {
                    toastr.error("Please upload picture of deposited challan", "Error!")
                }
                else if (this.ch.ModeOfPayment != 'Deposit' && this.ch.Attachment == '') {
                    toastr.error("Please upload picture/screenshot or transaction receipt", "Error!")
                }
                else {
                    var vm = this;
                    axios.post('/api/AdmissionApi/uploadChallan?id=' + vm.ID, {
                        ch: vm.ch
                    })
                        .then(function (response) {
                            if (response.data.status) {
                                toastr.success("Submitted Successfully");
                                vm.searchProspectStudents();
                                vm.ID = 0;
                                $('#mdlChallan').modal('hide');
                            }
                            else {
                                toastr.error(response.data.msg, "Opps!");
                            }
                        })
                }
            },

            //exportexcel() {

            //  $("#bs4-table").table2excel({
            //    // exclude CSS class
            //    exclude: ".noExl",
            //    name: "Worksheet Name",
            //    filename: "SomeFile",//do not include extension
            //    fileext: ".xls" // file extension
            //  });
            //  },

            exportexcel() {

                var vm = this;
                startReq();
                if (vm.Types != "1") {
                    toastr.error("Please select Posted Type to Download Excel Data", "Error!");
                    endReq();
                }
                else {
                    axios.post('/api/AdmissionApi/getexceldataofprospectus', {
                        filter: vm.filter,
                        type: 0,
                    })
                        .then(function (res) {
                            vm.exceldata = res.data.dataSet;
                            const xls = new XlsExport(vm.exceldata, 'Worksheet');
                            xls.exportToXLS('Prospect-Students.xls');
                            endReq();
                        })
                        .catch(function (error) {
                            console.log(error);
                        })
                }

            },

            pageLoad: function () {
                var vm = this;
                startReq();

                axios.post('/api/AdmissionApi/prospectStudentsPageLoad')
                    .then(function (pl) {
                        endReq();
                        vm.semesters = pl.data["sem"];
                        vm.degrees = pl.data["deg"];
                        vm.category = pl.data["category"];
                        vm.depID = pl.data["depID"];
                    })
            },

            loadOfferedPrograms: function () {
                if (this.filter.SemesterID && this.filter.DegreeID) {
                    var vm = this;
                    startReq();
                    axios.post('/api/AdmissionApi/loadOfferedPrograms?semID=' + vm.filter.SemesterID + '&degID=' + vm.filter.DegreeID)
                        .then(function (pl) {
                            endReq();
                            vm.programs = pl.data;
                        })
                }
            },

            newEntry() {
                if (this.selDegreeID == 0) {
                    toastr.error("Please select degree", "Error!");
                    return;
                }
                var vm = this;
                startReq();
                axios.post('/api/AdmissionApi/newEntry?ID=' + vm.selDegreeID)
                    .then(function (res) {
                        window.location.href = "DocumentVerificationForm.aspx";
                    })
                    .catch(function (error) {
                        console.log(error);
                    })

            },

            edit(id) {
                var vm = this;

                startReq();
                axios.post('/api/AdmissionApi/editProspectStudent?ID=' + id)
                    .then(function (res) {
                        endReq();
                        if (res.data.status)
                            window.open(res.data.url, '_blank');
                        else
                            redirect_blank("../Home/AccessDenied.aspx");

                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },

            loadDepartment() {
                var vm = this;
                vm.prospects = [];

                startReq();
                axios.post('/api/AdmissionApi/loadDepartments?ID=' + vm.filter.SemesterID + "_" + vm.filter.DegreeID)
                    .then(function (res) {
                        vm.departments = res.data;
                        endReq();
                    })
            },

            loadPrograms() {
                var vm = this;
                vm.prospects = [];

                startReq();
                axios.post('/api/AdmissionApi/loadPrograms?ID=' + vm.filter.SemesterID + "_" + vm.filter.DegreeID + "_" + vm.filter.DepartmentID)
                    .then(function (res) {
                        vm.programs = res.data;
                        endReq();
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },

            btnSearch() {

                startReq();

                var vm = this;
                if (vm.filter.SemesterID == 0) {
                    toastr.error("Please select Session", "Error!");
                    endReq();
                }

                if (vm.depID != 0) {
                    if (vm.filter.ProgramID == 0) {
                        toastr.error("Please select Program", "Error!");
                        endReq();
                        return;
                    }
                }

                axios.post('/api/AdmissionApi/searchProspectStudents', {
                    filter: vm.filter,
                    type: 0,
                })
                    .then(function (res) {
                        vm.showImage = vm.filter.DisplayPicture;
                        var table = $('#bs4-table').DataTable();
                        table.destroy();
                        vm.prospects = res.data;
                        vm.exceldatastatus = "enabled";

                        endReq();
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },

            printEntryTest(ID) {
                var vm = this;
                startReq();
                axios.post('/api/AdmissionApi/printEntryTest?ID=' + ID)
                    .then(function (res) {
                        endReq();
                        redirect_blank("../Admission/EntryTestPrint");
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },

            printAdmissionForm(id) {
                var vm = this;
                startReq();
                axios.post('/api/AdmissionApi/printAdmissionForm?ID=' + id)
                    .then(function (res) {
                        endReq();
                        window.open(res.data.url, '_blank');
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },

            printChallanForm(id) {
                var vm = this;
                startReq();
                axios.post('/api/AdmissionApi/printChallanForm?ID=' + id)
                    .then(function (res) {
                        endReq();
                        window.open(res.data.url, '_blank');
                        //redirect_blank(res.data.url);
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },

            saveDeleteID(id, ind) {
                $('#mdlConfirm').modal('show');
                this.delete.id = id;
                this.delete.ind = ind;
            },

            deleteProspect() {

                var vm = this;

                startReq();
                axios.post('/api/AdmissionApi/deleteProspectStudent?ID=' + vm.delete.id)
                    .then(function (res) {
                        endReq();
                        if (res.data == "yes") {
                            var table = $('#bs4-table').DataTable();
                            table.destroy();

                            vm.prospects.splice(vm.delete.ind, 1);
                            $('#mdlConfirm').modal('hide');
                            toastr.success("Deleted Successfully", "Done!");
                            vm.delete = { id: '', ind: '' };

                        }
                        else {
                            toastr.error("Error");
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            },

        }
    })</script>

<style>
    table thead tr th {
        background-color: #605ca8;
        color: white;
    }

    blink {
        -webkit-animation: 2s linear infinite condemned_blink_effect;
    }

    @-webkit-keyframes condemned_blink_effect {

        0% {
            visibility: hidden;
        }

        50% {
            visibility: hidden;
        }

        100% {
            visibility: visible;
        }
    }

    @keyframes condemned_blink_effect {
        0% {
            visibility: hidden;
        }

        50% {
            visibility: hidden;
        }

        100% {
            visibility: visible;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/onlineadmission/prospectStudents.vue